// Number formatting helpers for the German UI. The MeasureTable
// stores all numbers as Numbers in the toleranceStore, but inputs
// display + accept both German decimal notation (`0,3`) and US-style
// (`0.3`). `displayNum` renders for the input, `parseNum` parses on
// commit.
//
// Edge cases worth knowing:
//   - Empty string parses to NaN; callers default via `|| 0` where
//     appropriate. We don't return 0 here because "user typed nothing
//     yet" is genuinely different from "user typed 0".
//   - Trailing comma (`"0,"`) parses as 0.0. Live editing keeps the
//     draft string until blur so the user can finish typing.

export function parseNum(v) {
  if (v === '' || v === null || v === undefined) return NaN;
  const s = String(v).trim().replace(',', '.');
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
}

export function displayNum(v) {
  if (v === '' || v === null || v === undefined || Number.isNaN(v)) return '';
  return String(v).replace('.', ',');
}

export function fmt(n, decimals = 3) {
  if (!Number.isFinite(n)) return '-';
  return n.toFixed(decimals).replace('.', ',');
}

export function fmtSigned(n, decimals = 3) {
  if (!Number.isFinite(n)) return '-';
  const s = n.toFixed(decimals).replace('.', ',');
  return n >= 0 ? `+${s}` : s;
}
